import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Button, Link } from '@lacedltd/laced-components'
import { textStyle } from '../MobileNav.styles'

export const BackButton = styled(Button)({
  display: 'flex',
  margin: `${tokens.spacing[5]} ${tokens.spacing[6]}`,
  padding: 0,
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: tokens.spacing[5],
  alignSelf: 'stretch',
  textDecoration: 'none',
  textTransform: 'none',
  width: 'fit-content',

  '&:hover': { background: 'transparent' },

  span: { margin: 0 }
})

export const ContentSection = styled.div({
  padding: `0 0 ${tokens.spacing[10]} ${tokens.spacing[9]}`,

  'button:last-of-type': { borderBottom: 'none' }
})

export const NavLink = styled(Link)({
  display: 'block',
  width: '100%',
  margin: `${tokens.spacing[5]} 0`
})

export const Grid = styled.ul({
  display: 'grid',
  gridTemplateColumns: 'repeat(2,1fr)',
  columnGap: tokens.spacing[5]
})

export const MobileNavButton = styled(Button)(textStyle, {
  textDecoration: 'none',
  textTransform: 'none'
})
